import { normalize } from "./format";

/**
 * Amber "não publicar" lines that belong on a plan card, and only there.
 *
 * The page lists whatever GET /products returned. This function does not
 * invent a PMGO or GCM card: the caller renders a note only for a plan it
 * already has. A name that matches neither case returns null, and the card
 * leaves the line out.
 *
 * The strings are the file's own wording. The prices inside the PMGO line
 * are the conflict the note names; they are not the price the card charges.
 */

export const PMGO_SOLDADO_NOTE =
  "[BUG-03: card R$ 29,00 × banner R$ 29,90 — CEO confirma o preço · não publicar]";

export const GCM_NOTE = "[GCM — qual município? CEO confirma · não publicar]";

function hasWord(name: string, word: string): boolean {
  return new RegExp(`\\b${word}\\b`, "i").test(name);
}

export function planCardNote(name: string): string | null {
  const normalized = normalize(name);
  if (hasWord(normalized, "pmgo") && hasWord(normalized, "soldado")) {
    return PMGO_SOLDADO_NOTE;
  }
  if (hasWord(normalized, "gcm") || normalized.includes("guarda civil")) {
    return GCM_NOTE;
  }
  return null;
}
